import React, { Component } from 'react'
import propTypes from 'prop-types';
import {MDBContainer, MDBRow, MDBCol } from 'mdbreact';

export default class Results extends Component {
  render() {
    let imageContent;
    var imgStyle = {
      margin: 'auto 0'
    }
    const { images } = this.props;
    if (images) {
      imageContent = (
        <MDBContainer fluid>
         <MDBRow around>{images.map(img => (
          <MDBCol
          style={imgStyle}
          key={img.id}>
          <a href={img.pageURL}>
          <img
          src={img.webformatURL}
          alt="apiImage"/></a>
          </MDBCol>
         ))}
         </MDBRow>
        </MDBContainer>
      )
    } else {
      imageContent = null;
    }
    return (
      <div>
        {imageContent}
      </div>
    )
  }
}
  Results.propTypes = {
    images: propTypes.array.isRequired
}
